import './PathMap.css'

import React, { Dispatch, SetStateAction, useMemo } from 'react'
import { useState, useEffect } from 'react'
import { Services } from '@/services/services'
import { CurrentSession } from '@/services/repository/session'
import { useTranslations } from '@/hooks/useTranslations'
import { PathPoint } from '@/components/Map/PathMap'
import { defaultMapCenter } from '@/env/config'
import { LatLngExpression } from 'leaflet'
import { MapContainer, Marker, Polygon, Polyline, TileLayer } from 'react-leaflet'
import L from 'leaflet'
import { UserDeviceHistories, UserDeviceHistoriesData, UserDeviceHistoriesMachine } from '../../../requests/histories'

function findLastPoint(data: UserDeviceHistories | undefined): PathPoint | undefined {
  if (data === undefined) {
    return
  }
  let point: PathPoint | undefined
  const orderedKeys = Object.keys(data).sort();
  for (let i = 0; i < orderedKeys.length; i++) {
    const row = data[orderedKeys[i]]
    if (!row.path || row.path.length === 0) {
      continue
    }
    const currentPoint = row.path[row.path.length - 1]
    if (!point) {
      point = currentPoint
      continue
    }
    if (new Date(point.time) < new Date(currentPoint.time)) {
      point = currentPoint
    }
  }
  return point
}

export const CommunalUserPathMap = ({
  services,
  session,
  historiesData,
  selectedMachine,
  setSelectedMachine
}: {
  services: Services,
  session: CurrentSession,
  historiesData: UserDeviceHistoriesData
  selectedMachine: UserDeviceHistoriesMachine | undefined
  setSelectedMachine: Dispatch<SetStateAction<UserDeviceHistoriesMachine | undefined>>
}) => {
  // const machineId = useParams().mid
  const translates = useTranslations(services, session)
  const [myposition, setMyPosition] = useState<[number, number] | undefined>(undefined)
  // const { openModal } = useModal()
  // const [response, setResponse] = useState<UserDeviceHistoriesData>()
  // const [selected, setSelected] = useState<UserDeviceHistoriesMachine>()


  // const [hoveredId, setHoveredId] = useState<string | null>(null);

  useEffect(() => {
    // Function to handle geolocation success
    const handleSuccess = (location: GeolocationPosition) => {
      const { latitude, longitude } = location.coords
      setMyPosition([latitude, longitude])
    }

    // Function to handle geolocation error
    const handleError = (error: GeolocationPositionError) => {
      console.error('Error obtaining location:', error)
      // Fallback to a default position if geolocation fails
      setMyPosition(undefined)
    }

    // Check if geolocation is available
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(handleSuccess, handleError)
    } else {
      console.error('Geolocation is not supported by this browser.')
      // Fallback to a default position if geolocation is not supported
      setMyPosition(undefined)
    }
  }, [])

  const lastPoint = useMemo(() => {
    return findLastPoint(historiesData?.histories)
  }, [historiesData]);

  if (!historiesData || translates === undefined) {
    return <div className='spinner'></div>
  }
  
  const center: LatLngExpression = (lastPoint && {
    lat: lastPoint.lat,
    lng: lastPoint.lng
  }) || myposition || defaultMapCenter

  // function drawLine(name: string, color: string, path: Path) {
  //   return path?.map((area, i) => {
  //     const arr = []
  //     for (let i = 1; i < path.length; i++) {
  //       const id = name + "-" + area.time + i
  //       let a = path[i - 1]
  //       let b = path[i]
  //       arr.push(<Polygon
  //         key={id}
  //         positions={[a, b]}
  //         pathOptions={{
  //           color: color,
  //           fillOpacity: hoveredId === id ? 0.5 : 0.3,
  //           weight: hoveredId === id ? 7 : 4,
  //         }}
  //         eventHandlers={{
  //           mouseover: () => setHoveredId(id),
  //           mouseout: () => setHoveredId(null),
  //           click: () => {
  //             openModal((props) => PathPointBody({
  //               ...props,
  //               services,
  //               session,
  //               translates: session.translates,
  //               point: b
  //             }))
  //           }
  //         }}
  //       />)
  //     }
  //     return arr
  //   })
  // }

  return <div className='user-pathmap-wrapper'>
    <MapContainer attributionControl={false} center={center} zoom={13} style={{ height: '100%', minHeight: '250px', width: '100%' }}
      key={historiesData.hash} >
      <TileLayer
        attribution='evoltag.pl'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />
      {/* {selected ? response[selected].dividedPaths?.map((path) => drawLine(selected, response[selected].color || defaultColor, path))
        : Object.entries(response).map(([key, machine]) => machine.dividedPaths?.map((path) => drawLine(key, machine.color || defaultColor, path)))} */}

      {selectedMachine ? Object.entries(historiesData.histories).filter(([, row]) => row.imei === selectedMachine.imei).map((([, row]) => {
        return row.dividedPaths?.map((path) => (
          <Polyline
            positions={path?.map((prow) => ([prow.lat, prow.lng])) || []}
            pathOptions={{ color: historiesData.machines[row.imei].color, weight: 4 }}
          />
        ))
      })) : Object.entries(historiesData.histories).map(([key, row]) => row.dividedPaths?.map((path) => (
        <Polyline
          positions={path?.map((prow) => ([prow.lat, prow.lng])) || []}
          pathOptions={{ color: historiesData.machines[row.imei].color, weight: 4 }}
        />
      )))}

      {myposition ? <Marker
        key='my-location'
        position={myposition}
        icon={L.divIcon({
          className: 'car-icon',
          html: `<img src="/public/img/gps/i_am_here.png" style="width: 32px" />`,
          iconSize: [32, 32],
          iconAnchor: [16, 16],
        })}></Marker> : null}
    </MapContainer>

    <ul className='machines-nav'>
      {Object.entries(historiesData.machines).map(([key, machine]) => (<li
        className={`row ${machine.imei === selectedMachine?.imei ? 'selected' : ''}`}
        onClick={() => machine.imei === selectedMachine?.imei ? setSelectedMachine(undefined) : setSelectedMachine(machine)}>
        {[
          machine.type?.manufacturer,
          machine.type?.category ? session.translates.for(`machine.types.${machine.type.category}`) : null,
          machine.type?.model,
          machine.internalNumber,
        ].filter(val => val != null && val !== '').join(' > ')}
      </li>))}
    </ul>
  </div>
}
